import { render, staticRenderFns } from "./InputDiscount.vue?vue&type=template&id=fc4fd750&"
import script from "./InputDiscount.vue?vue&type=script&lang=js&"
export * from "./InputDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports